import { ActionReducerMapBuilder, createAsyncThunk } from '@reduxjs/toolkit';
import { RootState } from '../../../app/store';
import { Configuration } from '../../../shared/logik/models/configuration.model';
import logikApiService from '../../../shared/logik/services/logik-api.service';
import { ConfiguratorAPI } from '../../../shared/services/configurator.service';
import { updateTotalPrice } from '../../configurator/thunks/updateTotalPrice';
import { WidgetState, setMasterConfigurationId } from '../../widget/Widget.slice';
import { fetchConfigurationEventDataFromFields } from '../../../shared/logik/utils/fields.utils';
import { StockRequestsActionTypeEnum } from '../stock-requests.utils';

export type saveStockRequestResult = {
    masterId: string;
    configuration: Configuration;
};
export const saveStockRequest = createAsyncThunk<
    saveStockRequestResult,
    void,
    {
        state: RootState;
    }
>('stock-requests/save', async (_, thunkAPI): Promise<saveStockRequestResult> => {
    const dispatch = thunkAPI.dispatch;
    const state = thunkAPI.getState();
    const widgetState = state.widget;

    const uuid = widgetState.uuid;
    const productId = widgetState.productId;
    const threeKitId = widgetState.threeKitId;

    if (!uuid || !productId) return Promise.reject("Can't save product template: invalid configuration data");

    await dispatch(updateTotalPrice());
    const configuration = await logikApiService.saveConfiguration(uuid);

    const res = await ConfiguratorAPI.saveConfiguration({
        logikId: uuid,
        productId: productId,
        product: '',
        threeKitId: threeKitId ?? '',
        data: {
            ...fetchConfigurationEventDataFromFields(
                widgetState.configurationFields,
                configuration.products ?? [],
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                false,
                false,
                !widgetState.masterConfigurationId
                    ? StockRequestsActionTypeEnum.StockRequestNew
                    : StockRequestsActionTypeEnum.StockRequestEdit,
                null,
                widgetState.init?.launchObjectId,
            ),
            images: widgetState.images3D,
        },
        masterConfigurationId: widgetState.masterConfigurationId,
    });

    if (!res.masterConfigurationId) throw new Error('Failed to save master configuration');

    dispatch(setMasterConfigurationId(res.masterConfigurationId));

    return {
        masterId: res.masterConfigurationId,
        configuration: configuration,
    };
});

export const addSaveStockRequestCases = (
    builder: ActionReducerMapBuilder<WidgetState>,
): ActionReducerMapBuilder<WidgetState> => {
    return builder
        .addCase(saveStockRequest.pending, (state) => {
            state.saving = true;
        })
        .addCase(saveStockRequest.fulfilled, (state) => {
            state.saving = false;
        })
        .addCase(saveStockRequest.rejected, (state) => {
            state.saving = false;
        });
};
